// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"f22f5ad12a700f7b3940","526":"d9f250e6304e28ea6d63","611":"4ef41a01db3f7198059f","777":"39174aacc0e45016a9fd"}[chunkId] + ".js";
};